/**
 * Which agents are behind the latest release, from /api/v1/agent/version (agent/RELEASES.json, newest first).
 */
import type { AgentRelease, ReleaseImportance } from '@/types/agent';

const RANK: Record<ReleaseImportance, number> = { routine: 0, recommended: 1, security: 2 };
const VERSION = /^\d+\.\d+\.\d+$/;

export function compareVersions(a: string, b: string) {
  const left = a.split('.').map(Number), right = b.split('.').map(Number);
  for (let i = 0; i < 3; i++) if (left[i] !== right[i]) return Math.sign(left[i]! - right[i]!);
  return 0;
}

/** Releases newer than the agent's version and the most important level among them; null when current or unknown. */
export function updateFor(version: string | null | undefined, releases: AgentRelease[] = []) {
  if (!version || !VERSION.test(version) || !releases.length) return null;
  const missing = releases.filter((r) => compareVersions(r.version, version) > 0);
  if (!missing.length) return null;
  const importance = missing.reduce<ReleaseImportance>((top, r) => (RANK[r.importance] > RANK[top] ? r.importance : top), 'routine');
  return { latest: releases[0]!.version, importance, releases: missing };
}

export const IMPORTANCE_BADGES: Record<ReleaseImportance, string> = {
  routine: 'Update available', recommended: 'Recommended update', security: 'Security update',
};
